/**
 * @generated SignedSource<<0ebfa3b65dba15e5be1f0338f76bff54>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
export type CommunicationChannel = "ASYNC_REQUEST" | "CHAT" | "PHONE" | "VIDEO";
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadSource = "DOC2_U" | "PATIENT" | "SOFIA";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type Flexibility = "FIXED_TIME" | "FLEXIBLE" | "NOT_EARLIER";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
import { FragmentRefs } from "relay-runtime";
export type appointmentDrawerData_WaitingRoomAppointment$data = {
  readonly appointment: {
    readonly appointmentAttachments: ReadonlyArray<{
      readonly attachmentType: DocumentType;
      readonly fileName: string;
      readonly id: string;
      readonly thumbnailUrl: string | null;
      readonly uploadDate: string;
      readonly uploadSource: FileUploadSource;
      readonly uploadStatus: FileUploadStatus | null;
      readonly url: string;
    }>;
    readonly channel: CommunicationChannel;
    readonly chatDetails: {
      readonly chatThreadId: string;
    } | null;
    readonly fileUploadRequest: {
      readonly " $fragmentSpreads": FragmentRefs<"FileUploadRequestFragment">;
    } | null;
    readonly healthOverview: {
      readonly generalHealthInformation: {
        readonly " $fragmentSpreads": FragmentRefs<"GeneralHealthInformationFragment">;
      } | null;
      readonly vitalSign: {
        readonly " $fragmentSpreads": FragmentRefs<"VitalSignFragment">;
      } | null;
    } | null;
    readonly id: string;
    readonly isCompleted: boolean;
    readonly patient: {
      readonly patientFileLock: {
        readonly lockedBy: string | null;
      };
    };
    readonly questionnaireId: number | null;
    readonly reason: string;
    readonly service: Service;
    readonly status: AppointmentStatus;
    readonly telephoneLine: {
      readonly telephoneLineTranslations: ReadonlyArray<{
        readonly content: string;
        readonly language: Language;
      }>;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"RequestedMedicationsFragment" | "appointmentActions_appointment" | "appointmentDrawerAdditionalInfo_appointment" | "appointmentDrawerCardHeaderReviewAction_appointment" | "appointmentDrawerCardHeaderReviewStatus_appointment" | "appointmentDrawerCardHeader_appointment" | "appointmentDrawerHeader_appointment" | "appointmentDrawerQuestionnaire_appointment" | "appointmentDrawerStatusIndicator_appointment">;
  };
  readonly flexibility: Flexibility;
  readonly " $fragmentType": "appointmentDrawerData_WaitingRoomAppointment";
};
export type appointmentDrawerData_WaitingRoomAppointment$key = {
  readonly " $data"?: appointmentDrawerData_WaitingRoomAppointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentDrawerData_WaitingRoomAppointment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentDrawerData_WaitingRoomAppointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flexibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Appointment",
      "kind": "LinkedField",
      "name": "appointment",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "channel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AppointmentChatDetails",
          "kind": "LinkedField",
          "name": "chatDetails",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "chatThreadId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "service",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCompleted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "questionnaireId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ch_TelephoneLine",
          "kind": "LinkedField",
          "name": "telephoneLine",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ch_TelephoneLineTranslation",
              "kind": "LinkedField",
              "name": "telephoneLineTranslations",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "language",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "content",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AppointmentAttachment",
          "kind": "LinkedField",
          "name": "appointmentAttachments",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "thumbnailUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uploadDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attachmentType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uploadStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uploadSource",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "patient",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PatientFileLock",
              "kind": "LinkedField",
              "name": "patientFileLock",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lockedBy",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HealthOverview",
          "kind": "LinkedField",
          "name": "healthOverview",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "VitalSign",
              "kind": "LinkedField",
              "name": "vitalSign",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "VitalSignFragment"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GeneralHealthInformation",
              "kind": "LinkedField",
              "name": "generalHealthInformation",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "GeneralHealthInformationFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RequestedMedicationsFragment"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FileUploadRequest",
          "kind": "LinkedField",
          "name": "fileUploadRequest",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FileUploadRequestFragment"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "appointmentActions_appointment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "appointmentDrawerHeader_appointment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "appointmentDrawerCardHeader_appointment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "appointmentDrawerCardHeaderReviewAction_appointment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "appointmentDrawerCardHeaderReviewStatus_appointment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "appointmentDrawerQuestionnaire_appointment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "appointmentDrawerAdditionalInfo_appointment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "appointmentDrawerStatusIndicator_appointment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WaitingRoomAppointment",
  "abstractKey": null
};
})();

(node as any).hash = "44ad61c1fa5f24d59cd1c5acfb66c3f7";

export default node;
